import { singleton } from "tsyringe";
import QuestionRequestResource from "common/resources/Project/Config/Vote/QuestionRequestResource";
import QuestionResponseResource from "common/resources/Project/Config/Vote/QuestionResponseResource";
import BaseQuestionApi from "./BaseQuestionApi";

@singleton()
export default class QuestionApi extends BaseQuestionApi {
	public async getAllGeneral(projectId: string): Promise<QuestionResponseResource[]> {
		return this.getRequest<QuestionResponseResource[]>(`${this.getBaseUrl({ projectId })}`);
	}

	public async getAllCasting(projectId: string): Promise<QuestionResponseResource[]> {
		return this.getRequest<QuestionResponseResource[]>(`${this.getBaseUrl({ projectId })}/casting`);
	}

	public async create(projectId: string, data: QuestionRequestResource): Promise<QuestionResponseResource> {
		return this.postRequest<QuestionResponseResource>(`${this.getBaseUrl({ projectId })}`, { ...data });
	}

	public async update(projectId: string, questionId: string, data: QuestionRequestResource): Promise<QuestionResponseResource> {
		return this.putRequest<QuestionResponseResource>(`${this.getBaseUrl({ projectId })}/${questionId}`, { ...data });
	}

	public async delete(projectId: string, questionId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId })}/${questionId}`);
	}
}
